import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
import WalletJournal from "./walletJournal";
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';

const styles = theme => ({
    tableRow:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        '&:nth-of-type(2n)':{
            backgroundColor:'#f6f6f6'
        },
        '& td':{
            padding:7,
        },
        '&:first-of-type':{
            borderTop:0,
        },
    },
    tableHead:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        backgroundColor:'#6e6e6e',
        color:'white'
    },
    accountDetails:{
        width:'300px',
        position:'absolute',
        display:'none',
        //border:'2px solid ' + theme.navigation.selected.backgroundColor,
        backgroundColor:'white',
        top:0,
        right:50,
        zIndex:1000,
    },
    bankDetails:{
        '&:hover .details_drawer':{
            display:'block'
        }
    },
    debutton:{
        float:'right',
        marginBottom:'5px',
        marginRight:'5px'
    }
});

class WalletJournalButton extends Component {
    completeWithdrawal = () => {
        let content = (
            <WalletJournal investor={this.props.investor} />
        );

        this.props.context.update({
            popupContent: content,
            popupWidth:'400px',
            popupTitle:"Journal Entry"
        })
    }

    render() {
        const {classes} = this.props;
        return (
            <React.Fragment>
                <Button className={classes.debutton} size="small" variant="outlined" color="primary" onClick={this.completeWithdrawal}><AddIcon /> Add Journal Entry</Button>
            </React.Fragment>
        )
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(WalletJournalButton)));
